export const defaultBorderRadius = 4;
export const sidBarWidth = 300;
// card
export const cardHeight = 500;
export const cardWidth = 500;
// card content and actions (footer)
export const cardHeaderHeight = 70;
export const cardFooterHeight = 50;

//road number icon && font
export const roadIconFont = 'sans-serif';

//max height table
export const maxHeightTable = 450;
